import { useUserFeatures } from "../../contexts/UserFeaturesContext";

const useIsCreditMonitoringEnabled = (): boolean => {
  const features = useUserFeatures();
  return Boolean(
    features.array_plus_credit_reporting || features.olb_enable_credit_monitor
  );
};

export default useIsCreditMonitoringEnabled;
